import musikschule from "./musikschule.js"
import fach from "./fach.js"
import altersgruppe from "./altersgruppe.js"
import formular from "./formular.js"
import error from "./error.js"
import fortbildung from "./fortbildung.js"
import fortbildungsgruppe from "./fortbildungsgruppe.js"
import fortbildungpowerapp from "./fortbildungpowerapp.js"
import fortbildungsgruppepowerapp from "./fortbildungsgruppepowerapp.js"
import musikschulerhalter from "./musikschulerhalter.js"
import mangelinstrumentfoerderung from "./mangelinstrumentfoerderung.js"
import pruefungsordnung from "./pruefungsordnung.js"
import gemeinde from "./gemeinde.js"
import tdm from "./tdm.js"
import tda from "./tda.js"
import tdaworkshops from "./tdaworkshops"
import bewerbung from "./initiativbewerbung.js"
import gesamtabrechnung from "./gesamtabrechnung.js"
import veranstaltung from "./veranstaltung.js"
import wettbewerb from "./wettbewerb.js"
import kukudufoerderung from "./kukudufoerderung.js"

export default{
  service: {
    musikschule,
    fach,
    altersgruppe,
    formular,
    error,    
    fortbildung,
    fortbildungsgruppe,
    fortbildungpowerapp,
    fortbildungsgruppepowerapp,
    musikschulerhalter,
    mangelinstrumentfoerderung,
    pruefungsordnung,
    gemeinde,
    tdm,
    bewerbung,
    gesamtabrechnung,
    tda,
    tdaworkshops,
    veranstaltung,
    wettbewerb,
    kukudufoerderung
  }
}